import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../public/icons/workflow/close.svg'


const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "center"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "dialoghtml"
}
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_portal = _resolveComponent("portal")!

  return (_openBlock(), _createBlock(_component_portal, { to: "DialogsContainer" }, {
    default: _withCtx(() => [
      _createVNode(_Transition, { name: "modal" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-maskV2' : 'modal-mask')
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: _normalizeClass(['modal-container', _ctx.containerStyle, _ctx.useModalDialogsV2 ? 'modal-containerV2' : ''])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-headerV2' : 'modal-header')
                }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle(_ctx.useModalDialogsV2 ? {width: '100%'} : {paddingTop: '10px', paddingRight: '12px', paddingBottom: '6px', paddingLeft: '12px', width: '100%', height: '41px'})
                  }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "theme-svg",
                      id: "close",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                    })
                  ], 4)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-bodyV2' : 'modal-body'),
                  style: _normalizeStyle(_ctx.useModalDialogsV2 ? {textAlign: 'left'} : {textAlign: 'center'})
                }, [
                  (!_ctx.useModalDialogsV2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("img", { src: _ctx.IconUrl }, null, 8, _hoisted_3)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.useModalDialogsV2 ? 'left' : 'center'),
                    style: {"font-weight":"bold","font-size":"22px"}
                  }, _toDisplayString(_ctx.title), 3),
                  (!_ctx.IsHtml)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(_ctx.useModalDialogsV2 ? 'left' : 'center'),
                        style: {"margin-top":"40px"}
                      }, _toDisplayString(_ctx.message), 3))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", {
                          innerHTML: _ctx.$sanitize(_ctx.message),
                          style: {"padding":"12px","overflow-y":"auto","text-align":"left"}
                        }, null, 8, _hoisted_5)
                      ]))
                ], 6),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-footerV2' : 'modal-footer')
                }, [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _createVNode(_component_CommonButton, {
                      type: _ctx.ButtonType.Primary,
                      text: _ctx.Localizer.Localize('Ok_PascalCase'),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                    }, null, 8, ["type", "text"])
                  ], true)
                ], 2)
              ], 2)
            ])
          ], 2)
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}